const STORAGE_KEY = 'simulcast_recent_colors';
const MAX_RECENT = 16;

export function colorKey(c) {
	return `${c.r},${c.g},${c.b}`;
}

export function loadRecentColors() {
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		const parsed = raw ? JSON.parse(raw) : [];
		return Array.isArray(parsed) ? parsed.filter(isValidColor) : [];
	} catch {
		return [];
	}
}

function isValidColor(c) {
	return c && Number.isFinite(c.r) && Number.isFinite(c.g) && Number.isFinite(c.b);
}

export function pushRecentColor(color) {
	if (!isValidColor(color)) return loadRecentColors();
	const key = colorKey(color);
	const list = loadRecentColors().filter((c) => colorKey(c) !== key);
	list.unshift({ r: color.r, g: color.g, b: color.b });
	const trimmed = list.slice(0, MAX_RECENT);
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
	} catch {
		// ignore quota errors
	}
	return trimmed;
}

/** Lighting-friendly preset swatches. */
export const PRESET_SWATCHES = [
	{ r: 255, g: 255, b: 255 }, { r: 255, g: 250, b: 240 }, { r: 240, g: 235, b: 210 },
	{ r: 255, g: 220, b: 180 }, { r: 255, g: 197, b: 47 }, { r: 255, g: 160, b: 60 },
	{ r: 255, g: 100, b: 80 }, { r: 255, g: 60, b: 60 }, { r: 200, g: 16, b: 46 },
	{ r: 255, g: 130, b: 180 }, { r: 180, g: 100, b: 220 }, { r: 120, g: 80, b: 200 },
	{ r: 0, g: 120, b: 200 }, { r: 0, g: 90, b: 160 }, { r: 0, g: 180, b: 200 },
	{ r: 0, g: 160, b: 120 }, { r: 0, g: 140, b: 80 }, { r: 120, g: 200, b: 80 },
	{ r: 180, g: 220, b: 255 }, { r: 196, g: 206, b: 211 }, { r: 165, g: 172, b: 175 },
];
